import { useTranslation } from "react-i18next";
import { IconLock } from "@tabler/icons-react";

import { Text } from "@fragments";
import { getIntlLocale } from "@i18n";

function formatUntil(lockedUntil) {
    if (!lockedUntil) return null;
    const date = new Date(lockedUntil);
    if (Number.isNaN(date.getTime())) return null;
    return date.toLocaleString(getIntlLocale(), { dateStyle: "short", timeStyle: "short" });
}

/**
 * Too many wrong codes: verification is closed for this account for a while.
 * The only way out is the footer's "Entendi" (rendered by the controller).
 */
export default function LockedStep({ lockedUntil }) {
    const { t } = useTranslation("common");
    const until = formatUntil(lockedUntil);

    return (
        <div className="verification-locked">
            <span className="verification-locked__icon" aria-hidden="true">
                <IconLock />
            </span>
            <div className="verification-locked__copy">
                <Text.p contrast={8}>
                    {until
                        ? t("verification.locked.description", { until })
                        : t("verification.locked.descriptionNoDate")}
                </Text.p>
                <Text.caption contrast={6}>{t("verification.locked.hint")}</Text.caption>
            </div>
        </div>
    );
}
